import { ChangeEvent, KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';

interface EmbedFormProps {
  url: string;
  initialUrl: string | undefined;
  onUrlChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onSave: () => void;
  onCancel: () => void;
}

export const EmbedForm = ({ url, initialUrl, onUrlChange, onSave, onCancel }: EmbedFormProps) => {
  const { t } = useTranslation();
  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSave();
    }
  };

  return (
    <div className="h-full flex flex-col gap-4 p-4 bg-white/50 backdrop-blur-sm">
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700" htmlFor="embed-url">
          {t('embed.urlLabel')}
        </label>
        <div className="flex gap-2">
          <input
            className="flex-1 px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
            id="embed-url"
            placeholder={t('embed.urlPlaceholder')}
            type="text"
            value={url}
            onChange={onUrlChange}
            onKeyDown={handleKeyDown}
          />
          <button
            className="bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-colors"
            onClick={onSave}
          >
            {t('common.save')}
          </button>
          {initialUrl && (
            <button
              className="px-4 py-2 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
              onClick={onCancel}
            >
              {t('common.cancel')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
